<div class="loading" *ngIf="isLoading">
    <mat-progress-bar class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
</div>

<div class="upload-view">
    <aside class="side-block" *ngIf="partitionings">
        <h3>
            {{'files.form.simulation.title.fullLabel' | translate}}
            <app-tooltip [text]="'files.form.simulation.title.summary' | translate"></app-tooltip>
        </h3>
        <form [formGroup]="selectForm">
            <mat-form-field>
                <mat-label>{{ 'files.form.simulation.partitioning.shortLabel' | translate }}</mat-label>
                <mat-select id="partitioning-select" formControlName="partitioning">
                    <mat-option *ngFor="let partitioning of partitionings" [value]="partitioning.code">
                        {{ partitioning.text.shortLabel }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>

        <ng-container *ngIf="partitions && partitions.length">
            <h3>
                {{'files.form.simulation.partitions.shortLabel' | translate}}
                <app-tooltip [text]="'files.form.simulation.partitions.summary' | translate"></app-tooltip>
            </h3>
            <app-partitions-tree class="partitions-tree"
                [isMultiple]="true"
                [allowMultiCategories]="true"
                [partitions]="partitions"
                (toggleSelection)="onSelectPartition($event)"></app-partitions-tree>
        </ng-container>
    </aside>

    <section class="main-block" *ngIf="partitions && partitions.length">
        <ng-container>
            <h3>
                {{'files.form.simulation.send.shortLabel' | translate}}
                <app-tooltip [text]="'files.form.simulation.send.summary' | translate"></app-tooltip>
            </h3>
            <!-- <form>
                <section class="checkbox">
                    <mat-checkbox name="isClientImport" [(ngModel)]="isClientImport">
                        {{ 'files.form.clientImport.shortLabel' | translate }}
                        <app-tooltip [text]="'files.form.clientImport.summary' | translate"></app-tooltip>
                    </mat-checkbox>
                </section>
            </form> -->
            <app-upload-multi (afterFilesUpload)="onSendFilesInfo($event)"></app-upload-multi>
        </ng-container>

        <form *ngIf="selectedPartitions.length">
            <section class="checkbox">
                <mat-checkbox name="doesIncludeArticles" [(ngModel)]="doesIncludeArticles">
                    {{ 'files.form.simulation.includeArticle.shortLabel' | translate }}
                </mat-checkbox>
            </section>

            <mat-form-field *ngIf="categories.length > 1">
                <mat-label>{{ 'files.form.simulation.categories.shortLabel' | translate }}</mat-label>
                <mat-select name="selectedCategory" [(ngModel)]="selectedCategories" multiple>
                    <mat-option *ngFor="let category of categories" [value]="category.code">
                        {{ category.text.shortLabel }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <button mat-raised-button color="accent" class="download-btn"
                [disabled]="isLoading || !selectedCategories || !selectedCategories.length"
                (click)="onDownload()">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                {{ 'files.actions.download.shortLabel' | translate }}
            </button>
        </form>
    </section>
</div>
